import React from 'react';
import './style.scss';

const AboutSection = () => {

    const details = {
        spaceOperators: {
            title: "For Space Operators",
            list: [
                {
                    title: "Showcase Location Excellence",
                    text: "Earn FlexGrade Awards to showcase your excellence and attract premium occupiers"
                },
                {
                    title: "Elevate Brand Identify ",
                    text: "Differentiate your brand by highlighting your competitive strengths and market positioning "
                },
                {
                    title: "Data-Driven Insights ",
                    text: "Leverage FlexGrade analytics to benchmark against market standards to identify growth opportunities "
                },
                {
                    title: "Impactful Investment ",
                    text: "Make strategic CapEX investment backed by dynamic market insights"
                },
            ]
        },
        brokers: {
            title: "For Occupiers & Brokers",
            list: [
                {
                    title: "Expedite Selection Process",
                    text: "FlexGrade equips occupiers and brokers with the data needed to make confident, informed decisions "
                },
                {
                    title: "Standardized Quality Metrics",
                    text: "Easy to match search requirements with suitable workspaces, to compare and to evaluate portfolios"
                },
                {
                    title: "Streamline Procurement",
                    text: "Assessment addresses the requirements of multiple stakeholders, workplace management, HR, legal, IT and compliance"
                },
                {
                    title: "Market Intelligence",
                    text: "Industry professionals can effortlessly perform market research and analytics and generate reports via the FlexGrade’s platform"
                },
            ]
        },
    }

    return (
        <div className='about__section__main custom__container'>
            <div className='content__section'>
                <p>As an independent third-party, FlexGrade delivers an unbiased, data-driven grading system that sets objective benchmarks for quality, ensuring consistent, industry-leading standards across the sector.
                </p>
            </div>
            <div className='category__cards'>
                <div className='category__card first__card'>
                    <div className='header__section'>
                        <h3>
                            {details.spaceOperators.title}
                        </h3>
                        <div className='heading__border' />
                    </div>
                    <div className='list__container'>
                        {
                            details?.spaceOperators?.list?.map((v, i) => {
                                return <div className='list__item'>
                                    <h4>
                                        {v?.title}
                                    </h4>
                                    <p>
                                        {v?.text}
                                    </p>
                                </div>
                            })
                        }
                    </div>
                </div>
                <div className='category__card'>
                    <div className='header__section'>
                        <h3>
                            {details.brokers.title}
                        </h3>
                        <div className='heading__border' />
                    </div>
                    <div className='list__container'>
                        {
                            details?.brokers?.list?.map((v, i) => {
                                return <div className='list__item'>
                                    <h4>
                                        {v?.title}
                                    </h4>
                                    <p>
                                        {v?.text}
                                    </p>
                                </div>
                            })
                        }
                    </div>
                </div>
            </div>
            <div className='content__section'>
                <p>FlexGrade enhances transparency and reliability in the industry, building confidence between operators, occupiers, and brokers to establish flexible workspaces as dependable long-term solutions.
                </p>
            </div>
        </div>
    )
}

export default AboutSection;